import { render, staticRenderFns } from "./CTabGroup.vue?vue&type=template&id=49ac4a01&scoped=true&"
import script from "./CTabGroup.vue?vue&type=script&lang=js&"
export * from "./CTabGroup.vue?vue&type=script&lang=js&"
import style0 from "./CTabGroup.vue?vue&type=style&index=0&id=49ac4a01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ac4a01",
  null
  
)

export default component.exports